// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CorePricingEntityMapper from "../entity-mapper/CorePricingEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = CorePricingEntityMapper.execute;

var CampaignListResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var CampaignListResponseConverter = partial_arg(CampaignListResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$1(data) {
  return data;
}

var CampaignUpdateResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var CampaignUpdateResponseConverter = partial_arg$1(CampaignUpdateResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  CampaignListResponseConverterConfig ,
  CampaignListResponseConverter ,
  CampaignUpdateResponseConverterConfig ,
  CampaignUpdateResponseConverter ,
  
}
/* CampaignListResponseConverter Not a pure module */
